import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../utils/axiosConfig";
import { useUser } from "../../context/UserContext";

export default function AccountLinkComplete() {
  const navigate = useNavigate();
  const { refreshUser } = useUser();

  const [message, setMessage] = useState("Łączenie kont…");

  // Chroni przed dwukrotnym POST-em w React StrictMode
  const startedRef = useRef(false);

  // Informacja, czy komponent nadal jest aktywny
  const mountedRef = useRef(false);

  useEffect(() => {
    mountedRef.current = true;

    // React StrictMode może uruchomić effect drugi raz w dev.
    // Nie chcemy wtedy ponownie wywołać /account-link/complete.
    if (startedRef.current) {
      return () => {
        mountedRef.current = false;
      };
    }

    startedRef.current = true;

    const completeLink = async () => {
      const linkId = sessionStorage.getItem("accountLinkId");

      if (!linkId) {
        if (mountedRef.current) {
          setMessage(
            "Brak informacji o rozpoczętym łączeniu kont."
          );
        }
        return;
      }

      try {
        await axios.post(
          "/account-link/complete",
          {
            linkId,
          }
        );

        // Backend poprawnie połączył konta,
        // więc pending link nie jest już potrzebny.
        sessionStorage.removeItem("accountLinkId");

        if (!mountedRef.current) {
          return;
        }

        setMessage("Konta zostały połączone.");

        // Po linkowaniu pobieramy użytkownika ponownie.
        // Powinniśmy być teraz zalogowani jako primary account.
        await refreshUser();

        if (mountedRef.current) {
          navigate("/profile", {
            replace: true,
          });
        }
      } catch (err) {
        console.error(
          "Account link complete error:",
          err
        );

        if (mountedRef.current) {
          setMessage(
            err?.response?.data?.message ||
              "Nie udało się połączyć kont."
          );
        }

        // Celowo NIE usuwamy tutaj accountLinkId.
        // Dzięki temu można ewentualnie ponowić operację.
      }
    };

    completeLink();

    return () => {
      mountedRef.current = false;
    };
  }, [navigate, refreshUser]);

  return (
    <section className="auth-page">
      <div className="auth-container">
        <h2>Łączenie kont</h2>
        <p>{message}</p>
      </div>
    </section>
  );
}